import React, { useEffect, useState } from 'react';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Tooltip } from 'recharts';
import axios from 'axios';
import { WEBSERVICE_IP } from '../../functions/roots/webserviceIP';

const AnalisisActividad = () => {
  const [datos, setDatos] = useState([]);
  const [prediccion, setPrediccion] = useState(null);

  const usuarioId = sessionStorage.getItem('usuarioId');

  useEffect(() => {
    const fetchDatos = async () => {
      try {
        const res = await axios.get(`${WEBSERVICE_IP}/reportes/grafica/analisis-actividad/${usuarioId}`);
        const { semanas, dificultades, prediccionDificultad } = res.data;

        // Formatear los datos para el gráfico
        const formateado = semanas.map((semana, i) => ({
          semana,
          Dificultad: dificultades[i],
        }));

        // Agregar predicción como una semana adicional
        formateado.push({
          semana: `Predicción`,
          Dificultad: prediccionDificultad,
        });

        setDatos(formateado);
        setPrediccion(prediccionDificultad);
      } catch (err) {
        console.error('Error al obtener datos del análisis de actividad:', err);
      }
    };

    if (usuarioId) fetchDatos();
  }, [usuarioId]);

  return (
    <div style={{ textAlign: 'center' }}>
      {datos.length > 0 ? (
        <RadarChart cx="50%" cy="50%" outerRadius="80%" width={500} height={400} data={datos}>
          <PolarGrid />
          <PolarAngleAxis dataKey="semana" />
          <PolarRadiusAxis angle={30} domain={[0, 10]} />
          <Tooltip />
          <Radar name="Dificultad" dataKey="Dificultad" stroke="#8884d8" fill="#8884d8" fillOpacity={0.6} />
        </RadarChart>
      ) : (
        <p>Cargando datos...</p>
      )}
      {prediccion !== null && (
        <p style={{ marginTop: '10px', fontStyle: 'italic' }}>
          Predicción de dificultad próxima semana: <strong>{prediccion.toFixed(2)}</strong>
        </p>
      )}
    </div>
  );
};

export default AnalisisActividad;
